/**
 * Created by hsmasud on 5/3/2019.
 */
import {PlatformCommand} from '../commands/command-base';

export class BreadcrumbModel {
  id: string;
  title: string;
  type: string;
  relativeUrl: string;
  relativePath?: string;
  children: BreadcrumbModel [];
  isDisabled: boolean;
  api: string;
  platformCommand: PlatformCommand;
  constructor(){
    this.isDisabled = false;
  }
}
